"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageStatisticsComponent = UsageStatisticsComponent;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const UsageStatisticsResultsContainer = __importStar(require("../usage-statistics-results/container"));
const moment_1 = __importDefault(require("moment"));
function UsageStatisticsComponent(props) {
    return (React.createElement(Elements.ScrollContainer, null,
        React.createElement(Elements.StandardContainer, null,
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement(Elements.H2, null, "Usage statistics")),
            React.createElement(FilterOptions, Object.assign({}, props)),
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement("div", null,
                    React.createElement(Elements.StandardButton, { disabled: !props.canSearch, onClick: () => props.searchCallback() }, "Go"))),
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement(SearchResults, { searchOptions: props.searchOptions, showResults: props.showResults, activeSystemTypes: props.systemTypes, salesOrganisations: props.salesOrganisations })))));
}
function FilterOptions(props) {
    return (React.createElement("div", null,
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement(Elements.FlexContainerStack, null,
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Elements.H3, null, "Sales organization")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.salesOrganisationGroup, onChange: () => props.toogleSalesOrganisationGroupingCallback() }),
                            "Show in output (group by)")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.salesOrganisationFilter, onChange: () => props.toogleSalesOrganisationFilteringCallback() }),
                            "Filter")),
                    React.createElement(Elements.InnerContainer, null,
                        React.createElement(Elements.SelectBox, { size: 6, value: props.selectedSalesOrganisations, multiple: true, disabled: !props.salesOrganisationFilter, onChange: e => props.selectedSalesOrganisationsCallback(filterSelectedValues(e.target)) }, props.salesOrganisations.map(so => (React.createElement("option", { value: so.id, key: so.id },
                            so.name,
                            " (",
                            so.id,
                            ")"))))))),
            React.createElement(Elements.FlexContainerStack, null,
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Elements.H3, null, "System Types")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.systemTypeGroup, onChange: () => props.toogleSystemTypeGroupingCallback() }),
                            "Show in output (group by)")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.systemTypeFilter, onChange: () => props.toogleSystemTypeFilteringCallback() }),
                            "Filter")),
                    React.createElement(Elements.InnerContainer, null,
                        React.createElement(Elements.SelectBox, { size: 6, value: props.selectedSystemTypes, multiple: true, disabled: !props.systemTypeFilter, onChange: e => props.selectedSystemTypesCallback(filterSelectedValues(e.target)) }, props.systemTypes.map(st => (React.createElement("option", { value: st.id, key: st.id },
                            st.name,
                            " (",
                            st.id,
                            ")"))))))),
            React.createElement(Elements.FlexContainerStack, null,
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Elements.H3, null, "Status")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.statusGroup, onChange: () => props.toogleStatusGroupingCallback() }),
                            "Show in output (group by)")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.statusFilter, onChange: () => props.toogleStatusFilteringCallback() }),
                            "Filter")),
                    React.createElement(Elements.InnerContainer, null,
                        React.createElement(Elements.SelectBox, { size: 6, value: props.selectedStatus.map(s => s.toString()), multiple: true, disabled: !props.statusFilter, onChange: e => props.selectedStatusCallback(filterSelectedValues(e.target).map(s => Number.parseInt(s, 10))) }, props.status.map(s => (React.createElement("option", { value: s.id, key: s.id }, s.statusName)))))))),
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement(Elements.FlexContainerStack, null,
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Elements.H3, null, "Dates (status date)")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            " ",
                            React.createElement("input", { type: "checkbox", checked: props.dateGroup, onChange: () => props.toogleDateGroupingCallback() }),
                            "Show in output (group by)")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.dateFilter, onChange: () => props.toogleDateFilteringCallback() }),
                            "Filter")),
                    React.createElement(Elements.InnerContainer, null,
                        React.createElement(Elements.InputLabel, null, "From"),
                        React.createElement("input", { type: "date", disabled: !props.dateFilter, value: (0, moment_1.default)(props.selectedDateStart).format("YYYY-MM-DD"), onChange: e => props.selectedDateStartCallback(e.target.valueAsDate.toISOString()) })),
                    React.createElement(Elements.InnerContainer, null,
                        React.createElement(Elements.InputLabel, null, "To"),
                        React.createElement("input", { type: "date", disabled: !props.dateFilter, value: (0, moment_1.default)(props.selectedDateEnd).format("YYYY-MM-DD"), onChange: e => props.selectedDateEndCallback(e.target.valueAsDate.toISOString()) })))),
            React.createElement(Elements.FlexContainerStack, null,
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Elements.H3, null, "Users")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.usernameGroup, onChange: () => props.toogleUsernameGroupingCallback() }),
                            "Show in output (group by)")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            " ",
                            React.createElement("input", { type: "checkbox", checked: props.usernameFilter, onChange: () => props.toogleUsernameFilteringCallback() }),
                            "Filter")),
                    React.createElement(Elements.InnerContainer, null,
                        React.createElement(Elements.InputLabel, null, "Username"),
                        React.createElement(Elements.InputText, { type: "text", value: props.selectedUsername, disabled: !props.usernameFilter, onChange: e => props.selectedUsernameCallback(e.target.value) })))),
            React.createElement(Elements.FlexContainerStack, null,
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Elements.H3, null, "Deleted systems")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.deletedSystemGroup, onChange: () => props.toogleDeletedSystemGroupingCallback() }),
                            "Show in output (group by)")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.deletedSystemFilter, onChange: () => props.toogleDeletedSystemFilteringCallback() }),
                            "Filter")),
                    React.createElement(Elements.InnerContainer, null,
                        React.createElement(Elements.SelectBox, { multiple: true, size: 2, disabled: !props.deletedSystemFilter, onChange: e => props.selectedDeletedSystemsCallback(filterSelectedValues(e.target).map(d => Number.parseInt(d, 10))) },
                            React.createElement("option", { value: 1 }, "Active systems"),
                            React.createElement("option", { value: 0 }, "Deleted systems"))))),
            React.createElement(Elements.FlexContainerStack, null,
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Elements.H3, null, "GenesysNo")),
                    React.createElement("div", null,
                        React.createElement("label", null,
                            React.createElement("input", { type: "checkbox", checked: props.genesysNo, onChange: () => props.toogleGenesysNoCallback() }),
                            " ",
                            "Show first 20")))))));
}
function SearchResults({ activeSystemTypes, searchOptions, salesOrganisations, showResults }) {
    return showResults ? (React.createElement(UsageStatisticsResultsContainer.UsageStatisticsResultsContainer, { searchOptions: searchOptions, activeSystemTypes: activeSystemTypes, salesOrganisations: salesOrganisations })) : (React.createElement("div", null));
}
function filterSelectedValues(selectElement) {
    return Array.from(selectElement.options)
        .filter(o => o.selected)
        .map(o => o.value);
}
//# sourceMappingURL=usage-statistics-component.js.map